export default __webpack_public_path__ + "static/media/see-group-members-icon.747222c6.svg";